import React, { Component, PropTypes } from 'react';
import $ from 'jquery';
import Modal from 'common/components/Modal';
import CommentForm from './forms/CommentForm';
import 'plugins/forms';
import cx from 'classnames';

class AddCommentModal extends Component {
  constructor(props) {
    super(props);

    this._onChangeImage = this._onChangeImage.bind(this);
    this._onSubmit = this._onSubmit.bind(this);
  }

  _onChangeImage(file) {
    this._file = file;
  }

  _onSubmit(evt) {
    evt.preventDefault();

    const $form = $(evt.target)
      .closest('.modal')
      .find('form');
    const data = $form.serializeObject();

    this.props.onCreate(data, this._file);
  }

  render() {
    const { onClose, isCreating, createError } = this.props;

    const createClassName = cx('ui primary button icon labeled', {
      loading: isCreating,
    });

    return (
      <Modal isOpened closable onClose={onClose}>
        <div className="header">Nouveau commentaire</div>
        <div className="content">
          <CommentForm
            hasError={!!createError}
            onChangeImage={this._onChangeImage}
          />
        </div>
        <div className="actions">
          <button className={createClassName} onClick={this._onSubmit}>
            <i className="icon save" />
            Enregistrer
          </button>
        </div>
      </Modal>
    );
  }
}

AddCommentModal.propTypes = {
  isCreating: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
};

export default AddCommentModal;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/zones/plan/components/AddCommentModal.js